// Display-only comparison. The checkout always re-quotes prices on the server.
export const packComparison = (tiers, size, percent = 0) => {
  const sorted = tiers.filter(t => t.quantity > 0 && t.price > 0).slice().sort((a, b) => a.quantity - b.quantity);
  const selected = sorted.find(t => t.quantity === size);
  if (!selected) return null;
  const cents = Math.round(selected.price * 100);
  const subscriber = Math.round(cents * (100 - percent) / 100);
  const reference = Math.round(sorted[0].price * 100 / sorted[0].quantity * size);
  return { quantity: size, one_time_price: cents / 100, subscription_price: subscriber / 100,
    one_time_per_meal: Math.round(cents / size) / 100, subscription_per_meal: Math.round(subscriber / size) / 100,
    subscription_savings: (cents - subscriber) / 100, volume_savings: Math.max(0, reference - cents) / 100,
    reference_size: sorted[0].quantity, reference_total: reference / 100 };
};
export const addonPrice = (addon, quantity) => {
  const tiers = (addon.tiers || []).slice().sort((a, b) => a.quantity - b.quantity);
  const tier = [...tiers].reverse().find(t => t.quantity <= quantity) || tiers[0];
  return tier ? Math.round(tier.price / tier.quantity * quantity * 100) / 100 : 0;
};

export const dishOptionError = (items, selections) => {
  for (const pick of selections) {
    const item = items.find(row => row.item_id === pick.item_id);
    if (!item) return 'A selected dish is unavailable.';
    const groups = item.addon_groups || [];
    const picks = pick.addons || [];
    for (const group of groups.filter(g => g.mode !== 'ingredients')) {
      const count = picks.filter(p => p.group === group.key).length;
      if (count < (group.min_select || 0)) return `${item.name}: choose at least ${group.min_select} from ${group.label}.`;
      if (group.max_select != null && count > group.max_select) return `${item.name}: choose at most ${group.max_select} from ${group.label}.`;
    }
    const required = groups.reduce((sum, g) => sum + (g.min_select || 0), 0);
    if (item.max_total_addons && picks.length > Math.max(item.max_total_addons, required)) return `${item.name}: too many add-ons selected.`;
  }
  return '';
};

export const selectedDishName = (item, pick) => {
  const label = p => (item?.addon_groups || []).find(g => g.key === p.group)?.options?.find(o => o.key === p.option)?.label || p.option;
  const size = item?.size_options?.find(s => s.key === pick.size);
  const details = [...(size ? [size.label] : []), ...(pick.addons || []).map(p => `+ ${label(p)}`), ...(pick.removed_ingredients || []).map(p => `No ${label(p)}`)];
  return `${item?.name || ''}${details.length ? ` (${details.join('; ')})` : ''}`;
};

export const selectedItemsComparison = (items, selections) => {
  const count = selections.reduce((sum, p) => sum + p.quantity, 0);
  let regular = 0; let subscriber = 0;
  for (const pick of selections) {
    const item = items.find(row => row.item_id === pick.item_id);
    if (!item) return null;
    const extras = (pick.addons || []).reduce((sum, p) => sum + Math.round((item.addon_groups || []).find(g => g.key === p.group)?.options?.find(o => o.key === p.option)?.price * 100 || 0), Math.round((item.size_options || []).find(s => s.key === pick.size)?.price_delta * 100 || 0));
    regular += (Math.round(item.one_time_price * 100) + extras) * pick.quantity;
    subscriber += (Math.round(item.subscription_price * 100) + extras) * pick.quantity;
  }
  return { quantity: count, one_time_price: regular / 100, subscription_price: subscriber / 100,
    one_time_per_meal: count ? Math.round(regular / count) / 100 : 0,
    subscription_per_meal: count ? Math.round(subscriber / count) / 100 : 0,
    subscription_savings: Math.max(0, regular - subscriber) / 100, volume_savings: 0,
    reference_size: count, reference_total: regular / 100 };
};

export const fixedPackSelectionComparison = (comparison, items, selections) => {
  if (!comparison) return null;
  const priced = selectedItemsComparison(items.map(item => ({ ...item, one_time_price: 0, subscription_price: 0 })), selections);
  const upgrades = priced?.one_time_price || 0;
  const result = { ...comparison, upgrades_total: upgrades };
  for (const key of ['one_time', 'subscription']) {
    result[`${key}_price`] = Math.round((comparison[`${key}_price`] + upgrades) * 100) / 100;
    result[`${key}_per_meal`] = Math.round(result[`${key}_price`] / comparison.quantity * 100) / 100;
  }
  return result;
};
